import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  box-sizing: border-box;
`

const StyledActionTitle = styled.div`
  font-weight: 700;
  font-size: 26px;
  color: white;

  @media (max-width: 420px) {
    font-size: 16px;
  }
`

const BuildingName = styled.div`
  font-size: 16px;
  color: #5f6886;

  @media (max-width: 420px) {
    font-size: 14px;
  }
`

const ActionTitle = ({title, buildingName}) => {
  return (
    <Container>
      <StyledActionTitle>{title}</StyledActionTitle>
      <BuildingName>{buildingName}</BuildingName>
    </Container>
  )
}

export default ActionTitle
